import { z } from "zod";

const organisationBrandingSchema = z.object({
  logoURL: z
    .string()
    .refine((val) => !val || z.string().url().safeParse(val).success, {
      message: "Invalid URL format",
    })
    .optional(),
});
type OrganisationBrandingFormData = z.infer<typeof organisationBrandingSchema>;

export { organisationBrandingSchema };
export type { OrganisationBrandingFormData };
